import { APP_PREFIX, DOCTOR_PORTAL_PAGE, DOCTOR_PORTAL_PATIENT_CARD, DOCTOR_PORTAL_VISITS } from '@app/routes/urls';

/**
 * The doctor's route to one patient.
 *
 * A doctor's patient dashboard is NOT the staff one: `/dashboard/clients/:id/card`
 * resolves only for staff, so the shared client link helper — which every other
 * list in the product uses — sends a doctor to a page their role cannot open.
 * Anywhere the portal shows a patient's name, it links here.
 */
export const doctorPatientCardPath = (clientId: number | string): string =>
  `/${APP_PREFIX}/${DOCTOR_PORTAL_PAGE}/${DOCTOR_PORTAL_PATIENT_CARD.replace(':id', String(clientId))}`;

/**
 * The doctor's route to one visit.
 *
 * There is no route for a single visit in the portal - the read-only visit modal
 * opens over the visits list - so a link to one is the list with `?visit=<id>`,
 * which that page reads on load and opens the modal for.
 */
export const doctorVisitPath = (visitId: number | string): string =>
  `/${APP_PREFIX}/${DOCTOR_PORTAL_PAGE}/${DOCTOR_PORTAL_VISITS}?visit=${visitId}`;
